<template>
  <div class="offer-operations">
    <h3>Historial de operaciones</h3>
    <!-- Sin negociaciones  -->
    <div v-if="seeInitialActionBtns()" class="first-operation">
      <!-- Esperando respuesta -->
      <div v-if="!offerOrgEqualCurrentOrg()">
        <div class="alert info message" v-if="!offerAction">
          <vs-icon icon="feedback"></vs-icon>
          Ha recibido una oferta de {{ $t(`offer.type.${offer.offerType}`) }},
          por favor seleccione la acción que desea tomar.
        </div>
        <div
          v-if="
            offerAction === '' && this.$parent.$parent.view != 'admin' && !admin
          "
          class="offer-actions"
        >
          <button
            data-test="acceptOffer"
            @click="offerAction = 'accept!'"
            class="accept"
          >
            <vs-icon icon="check"></vs-icon> Aceptar
          </button>
          <button
            data-test="deneidOffer"
            @click="offerAction = 'cancel!'"
            class="reject"
          >
            <vs-icon icon="close"></vs-icon> Rechazar
          </button>
          <button
            data-test="negotiation"
            v-if="hasAnyTrue(offer.negotiableAttributes)"
            @click="newNegotiation"
            class="negotiate"
          >
            <vs-icon icon="compare_arrows"></vs-icon> Negociar
          </button>
        </div>
      </div>
      <!-- Sin acciones -->
      <div v-else>
        <div class="alert info">
          <vs-icon icon="sync_disabled"></vs-icon>
          Su oferta todavía no ha recibido una respuesta.
        </div>
        <button
          v-if="!offerAction"
          @click="offerAction = 'cancel!'"
          class="reject-offer"
        >
          <vs-icon icon="delete"></vs-icon> Cancelar oferta
        </button>
      </div>

      <div
        v-if="offerAction && offerAction != 'negotiate!'"
        class="confirm-action"
      >
        <div class="message">
          ¿Está seguro que desea
          {{ $t(`offer.negotiations.${offerAction}`) }} la oferta?
        </div>
        <div class="negotiation-actions">
          <button
            data-test="confirmOffeer"
            class="success"
            type="flat"
            icon="check"
            @click="offerFirstOperation"
          >
            Confirmar
          </button>
          <button
            data-test="cancelOffer"
            class="danger"
            type="flat"
            icon="close"
            @click="cleanNegotiation"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>

    <!-- Con negociaciones -->
    <div v-else>
      <!-- Tabla negociaciones -->
      <table
        class="grid-table offer-negotiations"
        v-if="!!negotiations.length && action != 'negotiate!'"
      >
        <thead>
          <tr>
            <th>Estado</th>
            <th>Vendedor</th>
            <th>Negociación</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="nego in negotiations" :id="nego.id" :key="nego.id">
            <td>
              <div
                v-if="nego.state === 'pending'"
                class="state"
                :class="nego.state"
              >
                <span
                  v-if="nego.senderId === currentUser.organizationId"
                  class="sended"
                >
                  Negociación enviada
                </span>
                <span v-else>
                  Negociación recibida
                </span>
              </div>
              <div v-else class="state" :class="nego.state">
                <span>
                  {{ $t(`offer.state.${nego.state}`) }}
                </span>
              </div>
            </td>
            <td>
              {{ nego.offeror.name }}
              <span class="date small">
                {{ localeDate(nego.createdAt) }}
              </span>
            </td>
            <td class="negotiable-attributes">
              <div
                v-if="isInNegotiation(nego, 'deliveryAtDestination')"
                class="switch"
              >
                <label for="negotiateDelivery">Entrega en destino:</label>
                <input
                  class="we-toggle"
                  :checked="nego.deliveryAtDestination"
                  type="checkbox"
                  name="negotiateDelivery"
                  v-model="hideIdentity"
                  @change="
                    attributes.deliveryAtDestination = $event.target.checked
                  "
                />
              </div>
              <div v-if="isInNegotiation(nego, 'price')">
                <span>
                  Precio:
                </span>
                <strong>
                  {{ localePrice(nego.price) }}
                  <small class="variance"
                    >(${{ negoDiff(nego.price, "price") }})</small
                  >
                </strong>
              </div>
              <!-- TODO: handlear cambios a campos correspondientes a calidad -->
              <!-- <div v-if="isInNegotiation(nego, 'quality')">
                <span>
                  Calidad:
                </span>
                <input :readonly="onlyReadField(nego.id)" :value="nego.quality" @input="attributes.quality = parseInt($event.target.value)">
              </div> -->
              <div v-if="isInNegotiation(nego, 'quantity')">
                <span>
                  Cantidad de animales:
                </span>
                <strong>
                  {{ nego.quantity }}
                  <small class="variance"
                    >({{ negoDiff(nego.quantity, "quantity") }})</small
                  >
                </strong>
              </div>
              <div v-if="isInNegotiation(nego, 'slaughterWeight')">
                <span>
                  Peso faena:
                </span>
                <strong>
                  {{ nego.slaughterWeight }} (± 5) Kgs
                  <small class="variance"
                    >({{
                      negoDiff(nego.slaughterWeight, "slaughterWeight")
                    }})</small
                  >
                </strong>
              </div>
              <div v-if="negotiationMsg && negotiation.id === nego.id">
                {{ negotiationMsg }}
              </div>
            </td>
            <td v-if="!admin" class="actions">
              <div
                vs-trigger-click
                v-show="canInteractOnNegotiation(nego)"
                class="buttons"
              >
                <span
                  @click="setNegotiation(nego, 'accept!')"
                  title="Aceptar"
                  class="action-btn accept"
                >
                  <vs-icon icon="check" color="green"></vs-icon>
                </span>
                <span
                  @click="setNegotiation(nego, 'reject!')"
                  title="Rechazar"
                  class="action-btn reject"
                >
                  <vs-icon icon="close" color="red"></vs-icon>
                </span>
                <span
                  @click="setNegotiation(nego, 'negotiate!')"
                  title="Negociar"
                  class="action-btn negotiate"
                >
                  <vs-icon icon="compare_arrows"></vs-icon>
                </span>
              </div>
              <div
                v-if="!canInteractOnNegotiation(nego) && action === ''"
                class="buttons"
              >
                <span
                  @click="setNegotiation(nego, 'cancel!')"
                  title="Cancelar"
                  class="action-btn cancel"
                >
                  <vs-icon icon="delete"></vs-icon> Cancelar
                </span>
              </div>
              <div v-if="negotiation.id === nego.id" class="confirmation">
                <button
                  class="success"
                  type="flat"
                  @click="takeActionOnNegotiation(nego)"
                >
                  Confirmar
                </button>
                <button class="danger" type="flat" @click="cleanNegotiation">
                  Cancelar
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Form negociación -->
    <div
      v-if="(offerAction === 'negotiate!' || action === 'negotiate!') && !admin"
      class="negotiation-form"
    >
      <div
        class="input-group format-type"
        v-if="!!offer.negotiableAttributes.price"
      >
        <input
          placeholder="Precio"
          data-test="input-priceNegotiation"
          ref="price"
          :value="negotiation.id ? negotiation.price : offer.price"
          @input="attributes.price = parseFloat($event.target.value)"
          :class="{ changed: !!attributes.price || !!offer.price }"
        />
        <label>Precio</label>
        <span class="text-validation">$/kg</span>
        <div
          v-if="this.errors.has('price')"
          class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
        >
          <span> {{ this.errors.first("price") }}</span>
        </div>
      </div>
      <div class="input-group" v-if="!!offer.negotiableAttributes.quantity">
        <input
          placeholder="Cantidad de animales"
          data-test="input-quantityAnimals"
          ref="quantity"
          :value="offer.quantity"
          @input="attributes.quantity = parseFloat($event.target.value)"
          :class="{ changed: !!this.attributes.quantity || !!offer.quantity }"
        />
        <label>Cantidad de animales</label>
        <div
          v-if="this.errors.has('quantity')"
          class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
        >
          <span> {{ this.errors.first("quantity") }}</span>
        </div>
      </div>
      <div
        class="input-group format-type"
        v-if="!!offer.negotiableAttributes.slaughterWeight"
      >
        <input
          placeholder="Precio Faena"
          ref="slaughterWeight"
          :value="offer.slaughterWeight"
          @input="attributes.slaughterWeight = parseFloat($event.target.value)"
          :class="{
            changed: !this.attributes.slaughterWeight || !!offer.slaughterWeight
          }"
        />
        <label>Peso Faena</label>
        <span class="text-validation">(± 5) Kgs</span>
        <div
          v-if="this.errors.has('slaughterWeight')"
          class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
        >
          <span> {{ this.errors.first("slaughterWeight") }}</span>
        </div>
      </div>
      <!-- TODO: handlear cambios a campos correspondientes a calidad -->
      <!-- <div v-if="!!offer.negotiableAttributes.quality">
        <span>
          Calidad:
        </span>
        <input @input="attributes.quality = event.target.value">
      </div> -->
      <div
        class="switch"
        v-if="!!offer.negotiableAttributes.deliveryAtDestination"
      >
        <label for="">Entrega en destino</label>
        <input
          class="we-toggle"
          ref="deliveryAtDestination"
          type="checkbox"
          name="deliveryAtDestination"
          :checked="offer.deliveryAtDestination"
          @change="attributes.deliveryAtDestination = $event.target.checked"
        />
      </div>

      <div v-if="!!this.negotiation.id" class="negotiation-actions">
        <button
          data-test="button-sendReNegotiation"
          class="success"
          type="flat"
          icon="check"
          @click="takeActionOnNegotiation(negotiation)"
        >
          Enviar
        </button>
        <button
          class="danger"
          type="flat"
          icon="close"
          @click="cleanNegotiation"
        >
          Cancelar
        </button>
      </div>
      <div v-else class="negotiation-actions">
        <button
          data-test="button-sendReNegotiation"
          class="success"
          type="flat"
          icon="check"
          @click="offerFirstOperation"
        >
          Enviar
        </button>
        <button
          class="danger"
          type="flat"
          icon="close"
          @click="cleanNegotiation"
        >
          Cancelar
        </button>
      </div>
      <div v-if="this.negotiationMsg" class="error">
        {{ $t(`offer.negotiations.${negotiationMsg}`) }}
      </div>
    </div>

    <vs-popup
      title="Pago Agro Nación"
      :active.sync="confirmPopup"
      :button-close-hidden="true"
      class="confirm-action agronacion"
    >
      <img
        alt="Logo Agronación"
        src="@/assets/images/logo_agronacion.png"
        class="logo-agronacion"
      />
      <div class="alert info">
        <vs-icon icon="warning"></vs-icon>
        <span>Está confirmando una operación con Pago Agro Nación.</span>
      </div>

      <div class="footer">
        <button @click="confirmPopup = false" class="btn cancel">
          Cancelar
        </button>
        <button
          class="btn confirm"
          @click="
            agreeWithANP = true;
            confirmPopup = false;
          "
        >
          Continuar
        </button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapState } from 'vuex'

const transactionateNegotiation = gql`
  mutation transactionateNegotiation(
    $negotiationId: Int!
    $currentUserToken: String!
    $action: String!
    $negotiableAttributes: NegotiationNegotiableAttributesInput
  ) {
    transactionateNegotiation(
      negotiationId: $negotiationId
      currentUserToken: $currentUserToken
      action: $action
      negotiableAttributes: $negotiableAttributes
    ) {
      code
      message
      success
    }
  }
`

const transactionateOffer = gql`
  mutation transactionateOffer(
    $currentUserToken: String!
    $offerId: Int!
    $action: String!
  ) {
    transactionateOffer(
      currentUserToken: $currentUserToken
      offerId: $offerId
      action: $action
    ) {
      code
      message
      success
    }
  }
`

const createNegotiation = gql`
  mutation createNegotiation(
    $offerId: Int!
    $negotiableAttributes: NegotiationNegotiableAttributesInput!
    $offerorId: Int
    $senderId: Int
    $currentUserToken: String!
  ) {
    createNegotiation(
      offerId: $offerId
      negotiableAttributes: $negotiableAttributes
      offerorId: $offerorId
      senderId: $senderId
      currentUserToken: $currentUserToken
    ) {
      code
      message
      success
    }
  }
`

export default {
  name: 'offer-negotiations',
  props: {
    offer: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    },
    negotiations: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    admin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      action: '',
      error: '',
      negotiation: {},
      offerAction: '',
      attributes: {},
      negotiationMsg: '',
      confirmPopup: false,
      agreeWithANP: false
    }
  },

  watch: {
    agreeWithANP () {
      this.offerAction = 'accept!'
      this.takeActionOnOffer()
    }
  },

  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser,
      offerId: state => state.Offer.offerInSidebar
    })
  },
  methods: {
    negotiateAttr (attr) {
      if (this.negotiations.length > 1) {
        return
      }
      if (this.negotiations.length === 1) {
        if (this.canInteractOnNegotiation(this.negotiations[0])) {
          this.action = 'negotiate!'
          this.$nextTick(() => this.$refs[attr].focus())
        }
      } else if (!this.offerOrgEqualCurrentOrg()) {
        this.offerAction = 'negotiate!'
        this.$nextTick(() => this.$refs[attr].focus())
      }
    },
    localeDate (str) {
      return new Date(Date.parse(str) + 3.6e6 * 3).toLocaleDateString()
    },
    setAttribute (attr) {
      this.attributes[attr] = parseFloat(event.target.value)
    },
    canInteractOnNegotiation (nego) {
      if (
        ['published', 'pending', 'in_negotiation'].includes(this.offer.state)
      ) {
        return (
          nego.senderId !== this.currentUser.organizationId &&
          this.negotiation.id !== nego.id &&
          nego.state === 'pending'
        )
      }
      return false
    },
    offerOrgEqualCurrentOrg () {
      return (
        this.offer.part.opener.organizationId ===
        this.currentUser.organizationId
      )
    },
    seeInitialActionBtns () {
      return (
        ['published', 'pending', 'in_negotiation'].includes(this.offer.state) &&
        !this.negotiations.length
      )
    },
    newNegotiation () {
      this.offerAction = 'negotiate!'
    },
    setAttrs (obj) {
      const attrs = Object.keys(this.offer.negotiableAttributes)
      const active = attrs.filter(field => {
        return this.offer.negotiableAttributes[field]
      })
      active.forEach(attr => {
        this.attributes[attr] = obj[attr]
      })
    },
    offerFirstOperation () {
      if (this.offerAction === 'negotiate!') {
        this.startNegotiation()
      } else {
        this.takeActionOnOffer()
      }
    },
    onlyReadField (id) {
      if (this.action === 'negotiate!' && this.negotiation.id === id) {
        return false
      }
      return true
    },
    isInNegotiation (negotiation, attribute) {
      if (
        this.negotiation.id === negotiation.id &&
        this.action === 'negotiate!' &&
        this.offer.negotiableAttributes[attribute]
      ) {
        return true
      } else if (
        this.offer.negotiableAttributes[attribute] &&
        !!negotiation[attribute] &&
        this.offer[attribute] !== negotiation[attribute]
      ) {
        return true
      }
      return false
    },
    hasAnyTrue (obj) {
      return !!Object.values(obj).find(q => q === true)
    },
    cleanNegotiation () {
      this.negotiation = {}
      this.action = ''
      this.offerAction = ''
      this.attributes = {}
    },
    setNegotiation (negotiation, action) {
      this.negotiation = negotiation
      this.action = action
      this.setAttrs(negotiation)
    },
    canNegotiate (obj) {
      // TODO: Support changes for quality group field
      const keys = Object.keys(this.attributes)
      var can = false
      keys.forEach(key => {
        var val = this.attributes[key]
        if (val === false || !!val || val > 0) {
          if (obj[key] !== val) {
            can = true
          }
        }
      })
      return can
    },
    notify (action) {
      if (action != 'negotiate!') {
        var title = 'Oferta ' + this.$t(`offer.action.${action}`)
        var text =
          'La operación ha sido ' +
          this.$t(`offer.action.${action}`) +
          ' con éxito'
      } else {
        var title = 'Negociación enviada'
        var text = 'Su negociación ha sido enviada'
      }
      this.$vs.notify({
        title: title,
        time: 8000,
        text: text,
        color: '#50b83d',
        position: 'top-right',
        icon: 'check_circle'
      })
    },
    takeActionOnNegotiation (neg) {
      var negotiationChanges = {}
      if (this.action === 'negotiate!') {
        if (!this.canNegotiate(neg)) {
          this.negotiationMsg = 'not_have_changes'
          return false
        }
        this.negotiationMsg = ''
        negotiationChanges = { negotiableAttributes: this.attributes }
      }
      axios
        .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
          query: print(transactionateNegotiation),
          variables: Object.assign(
            {
              negotiationId: neg.id,
              currentUserToken: localStorage.getItem('USER_TOKEN'),
              action: this.action
            },
            negotiationChanges
          )
        })
        .then(res => {
          if (!res.data.errors) {
            if (res.data.data.transactionateNegotiation.success) {
              this.error = ''
              this.$emit('close-sidebar')
              this.notify(this.action)
              this.cleanNegotiation()
            } else {
              this.error = res.data.data.transactionateNegotiation.code
            }
          }
        })
    },
    startNegotiation () {
      if (!this.canNegotiate(this.offer)) {
        this.negotiationMsg = 'not_have_changes'
        return false
      }
      this.negotiationMsg = ''
      axios
        .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
          query: print(createNegotiation),
          variables: {
            offerId: this.offer.id,
            negotiableAttributes: this.attributes,
            currentUserToken: localStorage.getItem('USER_TOKEN')
          }
        })
        .then(res => {
          if (!res.data.errors) {
            if (res.data.data.createNegotiation.success) {
              this.$emit('close-sidebar')
              this.notify('negotiate!')
              this.cleanNegotiation()
            } else {
              this.error = res.data.data.createNegotiation.code
            }
          }
        })
    },
    takeActionOnOffer () {
      if ((this.offerAction = 'accept!')) {
        if (this.offer.agroNacionPayment && !this.agreeWithANP) {
          this.confirmPopup = true
          return
        }
      }

      axios
        .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
          query: print(transactionateOffer),
          variables: {
            currentUserToken: localStorage.getItem('USER_TOKEN'),
            offerId: this.offer.id,
            action: this.offerAction
          }
        })
        .then(res => {
          if (!res.data.errors) {
            if (res.data.data.transactionateOffer.success) {
              this.error = ''
              this.$emit('close-sidebar')
              this.notify(this.offerAction)
              this.cleanNegotiation()
            } else {
              this.error = res.data.data.transactionateOffer.code
            }
          }
        }).catch(err => {})
    },
    negoDiff (attr, value) {
      let diff = attr - this.offer[value]
      if (diff === +diff && diff !== (diff | 0)) {
        diff = diff.toFixed(2)
      }
      if (diff > 0) {
        return '+ ' + diff
      } else {
        return diff
      }
    },
    localePrice (price) {
      return '$ ' + price.toLocaleString('es', { minimumFractionDigits: 2 })
    }
  }
}
</script>
